/* eslint-disable */
/* eslint-disable no-return-assign */
import React, {
  memo,
  useCallback,
  useEffect, useMemo, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import ModalEditPriceRoom from 'components/Modals/ModalEditPriceRoom';
import ModalEditQuantityRoom from 'components/Modals/ModalEditQuantityRoom';

import { ROOM_TYPE } from 'constants/index';

import { currencyFormat } from 'utils/currencyFormat';
import styles from './CalendarComponent.module.scss';

// function generateNext30Days() {
//   const result = [];
//   const start = new Date();
//   const end = new Date();
//   end.setDate(start.getDate() + 30);

//   for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
//     result.push(d.toISOString().split('T')[0]);
//   }

//   return result;
// }

function generateDates(startDate, endDate) {
  const result = [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    result.push(d.toISOString().split('T')[0]);
  }

  return result;
}

const compareDate = (date, dateCompare) => (moment(date).format('MM/DD/YYYY') === moment(dateCompare).format('MM/DD/YYYY'));

const LIMIT_RANK = 30;

function detectRoomStatus(data) {
  const classes = {
    AVAILABLE: 'DateContentColum--Available',
    FULL: 'DateContentColum--Full',
    CLOSE: 'DateContentColum--Closed',
  };

  const status = {
    AVAILABLE: 'Đặt được',
    FULL: 'Hết phòng',
    CLOSE: 'Đã đóng',
  };

  return {
    class: classes[data],
    status: status[data],
  };
}

function CalendarComponent(props) {
  const { t } = useTranslation();

  const {
    roomStatusList,
    dayStart,
    dayEnd,
    isHasFilter,
    handleAddEndDate,
    place,
    dayStartFormat,
    dayEndFormat,
    actionUpdateLocation,
  } = props;

  const scrollRef = useRef(null);

  const followRef = useRef([]);

  const [dates, setDates] = useState([]);
  const [isOpenPriceModal, setIsOpenPriceModal] = useState(false);
  const [dataPriceClick, setDataPriceClick] = useState({});
  const [isOpenQuantityModal, setIsOpenQuantityModal] = useState(false);
  const [dataQuantityClick, setDataQuantityClick] = useState({});

  const newData = useMemo(() => roomStatusList.map((room) => ({
    ...room,
    roomStatus: (dates.map((item) => {
      const dateCompare = room?.roomStatus?.find((data) => (
        compareDate(item, data.statusDate)));
      if (dateCompare) {
        return {
          ...dateCompare,
          room: room._id,
        };
      }

      return {
        roomStatus: 'CLOSE',
        prices: [],
        statusDate: moment(item).format('YYYY-MM-DD'),
        room: room._id,
      };
    })),
  })), [dates, roomStatusList]);

  const cacheEnd = useMemo(() => moment(dayEnd).format('YYYY-MM-DD'), [dayEnd]);
  const cacheStart = useMemo(() => moment(dayStart).format('YYYY-MM-DD'), [dayStart]);

  useEffect(() => {
    setDates(generateDates(cacheStart, cacheEnd).map((item) => moment(item)));
  }, [cacheEnd, cacheStart]);

  useEffect(() => {
    function handleScrollDate() {
      followRef.current.forEach((ref) => {
        // eslint-disable-next-line no-param-reassign
        ref.scrollLeft = scrollRef.current.scrollLeft;
      });
    }

    scrollRef.current.addEventListener('scroll', handleScrollDate);

    return () => {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener('scroll', handleScrollDate);
      }
    };
  }, [followRef]);

  const handleScroll = useCallback((e) => {
    if (Math.ceil(e.target.scrollLeft) + e.target.clientWidth >= e.target.scrollWidth
    && LIMIT_RANK <= 360 && !isHasFilter) {
      handleAddEndDate();
    }
  }, [handleAddEndDate, isHasFilter]);

  const onTogglePriceModal = useCallback((data) => () => {
    setIsOpenPriceModal((prev) => !prev);
    setDataPriceClick(data);
  }, []);

  const onToggleQuantityModal = useCallback((data) => () => {
    setIsOpenQuantityModal((prev) => !prev);
    setDataQuantityClick(data);
  }, []);

  const onQuickUpdateRoomStatus = useCallback((data) => () => {
    const dataUpdate = {
      roomInfo: {
        id: place,
        roomId: data.room,
        roomStatusId: data._id,
      },
      filter: {
        start: dayStartFormat,
        end: dayEndFormat,
        place,
      },
    };
    actionUpdateLocation(dataUpdate);
  }, [place, dayEndFormat, dayStartFormat]);

  return (
    <div className={styles.Component}>
      <div className="Header">
        <div className="ContentColum" />

        <div
          className="Header__Wrapper"
          ref={scrollRef}
          onScroll={handleScroll}
        >
          <table>
            <tbody>
              <tr>
                {
                  dates.map((item) => (
                    <th
                      key={crypto.randomUUID()}
                      className={`${item.format('dddd') === 'Saturday'
                      || item.format('dddd') === 'Sunday' ? 'DateContentColum--Strong' : ''} DateContentColum`}
                    >
                      {item && t(`global.${item.format('dddd')}`)}

                      <br />

                      <span>
                        {item.format('MM/DD')}
                      </span>

                      <br />

                      <span>
                        {item.format('YYYY')}
                      </span>
                    </th>
                  ))
                }
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {newData.map((room, i) => (
        <div key={room._id} className="RoomSection">
          <div className="TitleRoom">
            <h2>{room.name || ROOM_TYPE[room.roomName]?.label}</h2>

            <span>{`(Số ID phòng: ${room._id})`}</span>
          </div>

          <div className="BodyColumContent">
            <div className="ContentColum">
              <p>
                Trạng thái phòng
              </p>

              <p>
                Phòng để bán
              </p>

              {room.priceTypes.map((price) => (
                <p
                  key={price._id}
                >
                  {price.name}
                </p>
              ))}
            </div>

            <div ref={(el) => followRef.current[i] = el} style={{ overflow: 'hidden', flex: 1 }}>
              <table>
                <tbody>
                  <tr>
                    {room.roomStatus.map((item) => (
                      <th
                        key={crypto.randomUUID()}
                        className={`DateContentColum ${detectRoomStatus(item?.roomStatus).class}`}
                        onClick={onQuickUpdateRoomStatus(item, room._id)}
                      >
                        <span>
                          {detectRoomStatus(item?.roomStatus).status}
                        </span>
                      </th>
                    ))}
                  </tr>

                  <tr>
                    {room.roomStatus.map((item) => (
                      <td
                        key={crypto.randomUUID()}
                        className={`DateContentColum ${detectRoomStatus(item?.roomStatus).class}`}
                        data={item}
                        onClick={onToggleQuantityModal(item)}
                        onKeyDown={null}
                      >
                        {item?.availableRooms}
                      </td>
                    ))}
                  </tr>

                  {room.priceTypes.map((item) => (
                    <tr key={crypto.randomUUID()}>
                      {room.roomStatus.map((r) => {
                        const findPrice = r?.prices?.find(
                          (p) => p?.priceType === item?._id,
                        )?.price;

                        return (
                          <td
                            key={crypto.randomUUID()}
                            className={`DateContentColum ${detectRoomStatus(r?.roomStatus).class}`}
                            data={r}
                            onClick={onTogglePriceModal({
                              ...r,
                              prices: room.priceTypes.map((roomPriceType) => {
                                const priceFound = r.prices.find(
                                  (p) => p.priceType === roomPriceType._id,
                                );

                                return {
                                  price: priceFound?.price || 0,
                                  priceType: roomPriceType._id,
                                  _id: roomPriceType._id,
                                };
                              }),
                            })}
                            onKeyDown={null}
                          >
                            {findPrice
                              ? currencyFormat({ value: findPrice })
                              : ''}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}

      {
        isOpenQuantityModal
          ? (
            <ModalEditQuantityRoom
              isOpen={isOpenQuantityModal}
              onToggleModal={onToggleQuantityModal()}
              data={dataQuantityClick}
              place={place}
              dayStartFormat={dayStartFormat}
              dayEndFormat={dayEndFormat}
              roomStatusList={roomStatusList}
            />
          )
          : null
      }

      {
        isOpenPriceModal
          ? (
            <ModalEditPriceRoom
              isOpen={isOpenPriceModal}
              onToggleModal={onTogglePriceModal()}
              data={dataPriceClick}
              place={place}
              dayStartFormat={dayStartFormat}
              dayEndFormat={dayEndFormat}
              roomStatusList={roomStatusList}
            />
          )
          : null
      }
    </div>
  );
}

CalendarComponent.propTypes = {
  roomStatusList: PropTypes.instanceOf(Array),
  dayStart: PropTypes.instanceOf(Date).isRequired,
  dayEnd: PropTypes.instanceOf(Date).isRequired,
  isHasFilter: PropTypes.bool.isRequired,
  handleAddEndDate: PropTypes.func.isRequired,
  place: PropTypes.string.isRequired,
  dayStartFormat: PropTypes.string,
  dayEndFormat: PropTypes.string,
  actionUpdateLocation: PropTypes.func.isRequired,
};

CalendarComponent.defaultProps = {
  roomStatusList: [],
  dayStartFormat: '',
  dayEndFormat: '',
};

export default memo(CalendarComponent);
